import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { User_Interface } from 'src/app/Interface/User_Interface';
import { UserService } from 'src/app/Service/User/User.service';

@Component({
  selector: 'app-UserTreeview',
  templateUrl: './UserTreeview.component.html',
  styleUrls: ['./UserTreeview.component.scss']
})
export class UserTreeviewComponent implements OnInit {
  DataList_User:Array<User_Interface>=[]
  DataList_User_Selected:Array<User_Interface>=[]
  @Output() Outer_DataList_User_Selected=new EventEmitter<Array<User_Interface>>();


  constructor(
    private User_Service:UserService,
  ) { }

  ngOnInit() {
    this.ReadData_User()
  }

  ReadData_User(){

    this.User_Service.GetRecord().subscribe(
      data=>{

        this.DataList_User=data
        

        for(let item of this.DataList_User)
        {
          item.DeletingProccess=true
        }

        this.SetSelect_User()

      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.



      }
    )
  }

  OnChangeSelect_User(item:User_Interface)
  {
    item.DeletingProccess=!item.DeletingProccess
    this.SetSelect_User()

  }

  SetSelect_User()
  {
    this.DataList_User_Selected=[]
    for(let item of this.DataList_User)
    {
      if(item.DeletingProccess==true)
      {
        this.DataList_User_Selected.push(item)
      }
    }

    this.Outer_DataList_User_Selected.emit(this.DataList_User_Selected)

  }


}
